import { render, staticRenderFns } from "./raiseTicket.vue?vue&type=template&id=1496b7d6&scoped=true"
import script from "./raiseTicket.vue?vue&type=script&lang=js"
export * from "./raiseTicket.vue?vue&type=script&lang=js"
import style0 from "./raiseTicket.vue?vue&type=style&index=0&id=1496b7d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496b7d6",
  null
  
)

export default component.exports